export default {
  navbar: {
    home: 'Home',
    services: 'Services',
    portfolio: 'Portfolio',
    blog: 'Blog',
    contact: 'Contact',
  },
  hero: {
    marketing_ai: 'Marketing, Automation & AI',
    atemporal: 'Timeless',
    title: 'Strategic Marketing.<br />Real Innovation.',
    description: 'We partner with forward-thinking brands to accelerate their growth. Our approach combines data analysis with high-impact creativity and cutting-edge technological execution.',
  },
  portfolio: {
    subtitle: 'Portfolio',
    title: 'Featured',
    highlight: 'Projects',
    description: 'Impact strategies and marketing success cases',
    category: 'Success Cases',
    projects: {
      mia_astral: 'Mia Astral',
      erika_de_la_vega: 'Erika De La Vega',
      ismael_cala: 'Ismael Cala',
      foto_ahora: 'Foto Ahora',
      nawis_app: 'Nawis App',
      pfs_realty: 'PFS Realty',
      yogurt_boom: 'Yogurt Boom',
      runahr: 'Runa',
      wide_angle: 'Wide Angle',
      cachalo_y_gana: 'Cachalo y Gana',
      xcape: 'Xcape',
    },
  },
  services: {
    meta: {
      title: 'Digital Marketing Services | Strategy, E-commerce & Leads | Mood Agency',
      description: 'We offer comprehensive digital marketing services: business strategy, lead generation, e-commerce, cloud infrastructure, and customer experience to scale your brand.',
      keywords: 'digital marketing, digital strategy, e-commerce, lead generation, digital transformation, digital consulting, mood agency',
    },
    subtitle: 'What we drive',
    title: 'Strategic',
    highlight: 'Services',
    description: 'We merge marketing intelligence with innovation agility to create solutions that not only solve problems today but define success tomorrow.',
    items: {
      '01': {
        title: 'Strategic Marketing',
        description: 'We transform your vision into tangible results through data analysis, brand positioning, and accelerated growth strategies.',
        list: ['Market Research', 'Branding & Identity', 'Growth Hacking', 'Content Strategy'],
      },
      '02': {
        title: 'Digital Innovation',
        description: 'We design and develop digital products that break boundaries, using cutting-edge technology to create memorable experiences.',
        list: ['UX/UI Product Design', 'Digital Ecosystem Development', 'Technological Transformation', 'AI Applied to Marketing'],
      },
      '03': {
        title: 'Performance & Leads',
        description: 'We build high-efficiency acquisition infrastructures to convert audiences into loyal customers in a scalable way.',
        list: ['B2B/B2C Lead Generation', 'Ads & Social Media', 'Conversion Rate Optimization (CRO)', 'Automated Email Marketing'],
      },
      '04': {
        title: 'E-commerce & Sales',
        description: 'We optimize every touchpoint of the buying process to maximize return on investment across digital channels.',
        list: ['Online Sales Platforms', 'Sales Automation', 'Advanced Analytics', 'Retention Strategies'],
      },
    },
    cta: {
      title: 'Ready to elevate your <span class="italic text-gray-400">Strategy?</span>',
      button: 'Let\'s talk about your project',
    },
  },
  contact: {
    subtitle: 'Let\'s talk',
    title: 'Direct',
    highlight: 'Contact',
    description: 'We are here to transform your ideas into high-impact marketing and innovation strategies. Tell us about your project and let\'s discover how we can scale together.',
  },
  footer: {
    cta: {
      title: 'Let\'s build',
      highlight: 'together.',
      button: 'Contact us',
    },
    social: {
      title: 'Social Media',
    },
  },
};
